module.exports = __webpack_public_path__ + "img/DO.3fe1405c.svg";